import { render, staticRenderFns } from "./FooterControl.vue?vue&type=template&id=42048ccc&scoped=true"
var script = {}
import style0 from "./FooterControl.vue?vue&type=style&index=0&id=42048ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42048ccc",
  null
  
)

export default component.exports